import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { TranslationService, WhitelistService } from '@dch/ng-common';
import { forkJoin, of } from 'rxjs';
import { catchError, first, map, mergeMap, switchMap } from 'rxjs/operators';
import { MyScarletService } from 'src/app/my-bill/services/my-scarlet.service';
import { RemoteLoggerService } from 'src/app/my-bill/services/remote-logger.service';
import {
  getAppInitializationFailure,
  getAppInitializationRequest,
  getAppInitializationSuccess,
} from '../actions';

@Injectable()
export class AppInitializationEffects {
  getAppInitialzation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getAppInitializationRequest),
      switchMap((action) => {
        const app = this.myScarletService.isScarlet() ? 'epic' : 'myproximus';
        const translations$ = this.translationService
          .addTranslationsFromOTAFor(app, 'bills')
          .pipe(
            first(),
            map((response) => {
              if (response) {
                return getAppInitializationSuccess();
              } else {
                this.remoteLoggerService.logErrorImmediately(
                  'OTA translations not loaded',
                  new Error('OTA translations not loaded')
                );
                return getAppInitializationFailure();
              }
            }),
            catchError(() => {
              this.remoteLoggerService.logErrorImmediately(
                'OTA translations not loaded',
                new Error('OTA translations not loaded')
              );
              return of(getAppInitializationFailure());
            })
          );
        const whiteListingConfig$ = this.whitelistService
          .getWhiteListConfiguration()
          .pipe(
            first(),
            map((response) => {
              if (!response) {
                this.remoteLoggerService.logErrorImmediately(
                  'whiteListing configuration not loaded',
                  new Error('whiteListing configuration not loaded')
                );
              }
              return getAppInitializationSuccess();
            }),
            catchError((error) => {
              this.remoteLoggerService.logErrorImmediately(
                'whiteListing configuration not loaded',
                new Error('whiteListing configuration not loaded')
              );

              return of(getAppInitializationSuccess());
            })
          );
        return forkJoin([translations$, whiteListingConfig$]).pipe(
          mergeMap((response) => [response[0]])
        );
      })
    )
  );

  constructor(
    private actions$: Actions,
    private translationService: TranslationService,
    private myScarletService: MyScarletService,
    private whitelistService: WhitelistService,
    private remoteLoggerService: RemoteLoggerService
  ) {}
}
